import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#083d66] border-t border-[#0A4A7A]">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Värmdö Hörsel</h3>
            <p className="text-gray-300 text-sm">{t('hero.subtitle')}</p>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">{t('footer.contactInfo')}</h4>
            <div className="space-y-2 text-sm text-gray-300">
              <p><a href="tel:+46723344774" className="hover:text-white">{t('contact.phone')}: 072-334 47 74</a></p>
              <p><a href="mailto:info@varmdohorsel.se" className="hover:text-white">{t('contact.email')}: info@varmdohorsel.se</a></p>
            </div>
          </div>
          <div>
            <h4 className="text-sm font-semibold text-white mb-4">{t('footer.quickLinks')}</h4>
            <div className="space-y-2 text-sm">
              <Link to="/location" className="text-gray-300 hover:text-white block">{t('nav.location')}</Link>
              <Link to="/privacy" className="text-gray-300 hover:text-white block">{t('footer.privacy')}</Link>
              <Link to="/terms" className="text-gray-300 hover:text-white block">{t('footer.terms')}</Link>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-[#0A4A7A]">
          <p className="text-center text-sm text-gray-400">© 2024 Värmdö Hörsel. {t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
